import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import FeaturedVideos from './components/FeaturedVideos';
import CategoryPreview from './components/CategoryPreview';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <FeaturedVideos />
        <CategoryPreview />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}